/* tslint:disable */
/* eslint-disable */
/**
 * Lightly API
 * Lightly.ai enables you to do self-supervised learning in an easy and intuitive way. The lightly.ai OpenAPI spec defines how one can interact with our REST API to unleash the full potential of lightly.ai
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@lightly.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGeneric.mustache
// synched 02.02.2023
import * as yup from 'yup';
import typia from 'typia';
import * as fastJSON from 'fast-json-stringify';
import { Options, ArraySchema, ObjectSchema } from 'fast-json-stringify';
import { exists, mapValues } from '../runtime';
/*
causes circular dependendies
*/
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGenericInterfaces.mustache
// synced: 17.07.2023
/**
 *
 * @export
 * @interface DockerWorkerConfigV3LightlyCriterion
 *
 */
// create custom validators for the regexes
export interface DockerWorkerConfigV3LightlyCriterion {
    /**
     *
     * #type number
     * #memberof DockerWorkerConfigV3LightlyCriterion
        
     * @exclusiveMinimum 0.0
        
         */
    temperature?: number;
}
/**
 * Check if a given object implements the DockerWorkerConfigV3LightlyCriterion interface.
 */
export function instanceOfDockerWorkerConfigV3LightlyCriterion(value: object): boolean {
    let isInstance = true;
    return isInstance;
}
/* LIGHTLY CUSTOM START -> modelGeneric */
export const DockerWorkerConfigV3LightlyCriterionTypiaAssertEquals = (input: any) => {
    return ((input: any): DockerWorkerConfigV3LightlyCriterion => {
        const __is = (input: any, _exceptionable: boolean = true): input is DockerWorkerConfigV3LightlyCriterion => {
            const $io0 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.temperature || "number" === typeof input.temperature && 0 < input.temperature) && (0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["temperature"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            return "object" === typeof input && null !== input && false === Array.isArray(input) && $io0(input, true);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is DockerWorkerConfigV3LightlyCriterion => {
                const $guard = (typia.createAssertEquals as any).guard;
                const $join = (typia.createAssertEquals as any).join;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.temperature || "number" === typeof input.temperature && (0 < input.temperature || $guard(_exceptionable, {
                    path: _path + ".temperature",
                    expected: "number (@exclusiveMinimum 0)",
                    value: input.temperature
                })) || $guard(_exceptionable, {
                    path: _path + ".temperature",
                    expected: "(number | undefined)",
                    value: input.temperature
                })) && (0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["temperature"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                return ("object" === typeof input && null !== input && false === Array.isArray(input) || $guard(true, {
                    path: _path + "",
                    expected: "DockerWorkerConfigV3LightlyCriterion",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "DockerWorkerConfigV3LightlyCriterion",
                    value: input
                });
            })(input, "$input", true);
        return input;
    })(input);
};
export const DockerWorkerConfigV3LightlyCriterionTypiaAssertStringify = (input: DockerWorkerConfigV3LightlyCriterion): string => {
    return ((input: any): string => { const assert = (input: any): DockerWorkerConfigV3LightlyCriterion => {
        const __is = (input: any): input is DockerWorkerConfigV3LightlyCriterion => {
            const $io0 = (input: any): boolean => undefined === input.temperature || "number" === typeof input.temperature && !Number.isNaN(input.temperature) && 0 < input.temperature;
            return "object" === typeof input && null !== input && false === Array.isArray(input) && $io0(input);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is DockerWorkerConfigV3LightlyCriterion => {
                const $guard = (typia.createAssertStringify as any).guard;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => undefined === input.temperature || "number" === typeof input.temperature && !Number.isNaN(input.temperature) && (0 < input.temperature || $guard(_exceptionable, {
                    path: _path + ".temperature",
                    expected: "number (@exclusiveMinimum 0)",
                    value: input.temperature
                })) || $guard(_exceptionable, {
                    path: _path + ".temperature",
                    expected: "(number | undefined)",
                    value: input.temperature
                });
                return ("object" === typeof input && null !== input && false === Array.isArray(input) || $guard(true, {
                    path: _path + "",
                    expected: "DockerWorkerConfigV3LightlyCriterion",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "DockerWorkerConfigV3LightlyCriterion",
                    value: input
                });
            })(input, "$input", true);
        return input;
    }; const stringify = (input: DockerWorkerConfigV3LightlyCriterion): string => {
        const $tail = (typia.createAssertStringify as any).tail;
        const $so0 = (input: any): any => `{${$tail(`${undefined === input.temperature ? "" : `"temperature":${undefined !== input.temperature ? input.temperature : undefined}`}`)}}`;
        return $so0(input);
    }; return stringify(assert(input)); })(input);
};
export const DockerWorkerConfigV3LightlyCriterionValidatorShape = {
    'temperature': yup.number().min(0.0),
};
export const DockerWorkerConfigV3LightlyCriterionValidator = yup.object().shape(DockerWorkerConfigV3LightlyCriterionValidatorShape);
export const DockerWorkerConfigV3LightlyCriterionStringifyShapeProperties: ObjectSchema['properties'] = {
    'temperature': {
        'type': 'number',
        'exclusiveMinimum': 0.0,
    } as unknown as fastJSON.NumberSchema,
};
export const DockerWorkerConfigV3LightlyCriterionStringifyShape: ObjectSchema = {
    title: 'DockerWorkerConfigV3LightlyCriterion Stringifier',
    type: 'object',
    properties: {
        ...DockerWorkerConfigV3LightlyCriterionStringifyShapeProperties
    },
    required: [],
};
export const DockerWorkerConfigV3LightlyCriterionStringifyCompiled = (typeof process === 'object' && String(process) === '[object process]') ?
    fastJSON.build(DockerWorkerConfigV3LightlyCriterionStringifyShape, {
        ajv: {
            // since we are already doing this with yup, lets skip
            validateSchema: false,
            ownProperties: true,
            validateFormats: false,
        },
        largeArrayMechanism: 'json-stringify',
        largeArraySize: 1000,
    } as Options)
    :
        () => { throw new Error('fast-json-stringify only works in nodejs'); };
export const DockerWorkerConfigV3LightlyCriterionStringify: (data: DockerWorkerConfigV3LightlyCriterion) => string = DockerWorkerConfigV3LightlyCriterionStringifyCompiled;
/* LIGHTLY CUSTOM END -> Generic */
export function DockerWorkerConfigV3LightlyCriterionFromJSON(json: any): DockerWorkerConfigV3LightlyCriterion {
    return DockerWorkerConfigV3LightlyCriterionFromJSONTyped(json, false);
}
export function DockerWorkerConfigV3LightlyCriterionFromJSONTyped(json: any, ignoreDiscriminator: boolean): DockerWorkerConfigV3LightlyCriterion {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    /* causes circular depdendencies
*/
    return {
        'temperature': !exists(json, 'temperature') ? undefined : json['temperature'],
    };
}
export function DockerWorkerConfigV3LightlyCriterionToJSON(value?: DockerWorkerConfigV3LightlyCriterion | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'temperature': value.temperature,
    };
}
